import Rails from "@rails/ujs"
Rails.start()

import "@hotwired/turbo-rails"
import 'bootstrap'

import '../javascript/controllers'
